import * as React from "react";
import { Row, Col } from "antd";

export interface Props {
    children?: React.ReactNode
}

export interface State {
}

export default class TrackedBolTermsConditionText extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)

        this.state = {
        }
    }

    render() {
        return (
            <Row>
                <Col>
                    <p style={{}}>
                        I authorize Kingston Wharves Limited (“KWL”) and their respective agents, employees, affiliates,
                        directors and officers (collectively referred to as “Service Provider”) to act on my behalf with
                        respect to the Express Customs clearance, declaration and payment of any and all Customs charges
                        that may be applicable to shipments on my behalf (hereinafter referred to as “the Service”).
                    </p>

                    <p >
                        By signing and submitting this authorization, I acknowledge and agree that:
                    </p>
                    <ol>
                        <li>
                            <p >
                                Service Provider shall not be obligated to release Cargo sent by or consigned to me until such time
                                as I have reimbursed or paid to Service Provider all charges levied by Service Provider and/or paid by Service Provider on my behalf.
                            </p>
                        </li>
                        <li>
                            <p >
                                Service Provider may in its discretion modify, suspend, restrict access to, or terminate the Service at any
                                time without liability or prior notice.
                            </p>
                        </li>
                        <li>
                            <p >
                                Service Provider is not liable for indirect, special or consequential losses, howsoever caused, arising out of the use of the Service.
                                In particular, KWL is not liable for damage to the contents of a shipment where the packing was found to be inadequate for the nature of the goods,
                                or where the damage is caused by any reason other than the negligence of KWL.
                            </p>
                        </li>
                        <li>
                            <p >
                                The Service may not be used for commercial cargo or restricted or prohibited commodities including hazardous materials, live animals,
                                perishable items, human remains, wet cargo, precious metals, cash, monetary instruments, high value jewelry, manuscripts, contraband, etc.
                            </p>
                            <p>
                                Hazardous materials include, but are not limited to explosives; gases (compressed, deeply refrigerated, liquefied or dissolved under pressure);
                                 flammable and combustible liquids; flammable solids; substances liable to spontaneous combustion; substances that on contact with water emit
                                 flammable gases; oxidizing substances; organic peroxides, poisonous (toxic) and infectious substances; radioactive nuclear substances; corrosives;
                                  miscellaneous products, substances or organisms which may reasonably be considered to be dangerous to life, health, property or the environment
                                  when handled, offered for transport by air or transported by air; goods that are otherwise by their nature or quantity either singly or collectively
                                   are liable to endanger life or imperil property.
                            </p>

                            <p >
                                I may not cause or attempt to cause Service Provider to receive, inspect or deliver any package containing hazardous materials.
                                Moreover, I will be solely liable for all damages that may arise from any accidents or incidents involving hazardous materials.
                            </p>
                        </li>
                        <li>
                            <p >
                                I authorize to the Jamaica Customs Agency (JCA), its agents and any other Government Authority, and their agents to inspect
                                my shipments and if necessary, to detain, confiscate, or destroy shipments that pose a threat to national security, and to seize
                                shipments in accordance with the provisions of the Customs Act. In such cases I will defend, indemnify, and hold harmless Service
                                Provider from any demands, claims, damages, liabilities, expenses or harms, including attorney’s fees, arising in connection with inspecting,
                                 detaining, confiscating, storing, and destroying such shipments.
                        </p>
                            <p style={{ marginTop: 5, marginLeft: 5 }}>
                                Service Provider will promptly notify me upon learning of a shipment being detained, confiscated, or destroyed.
                                I will indemnify, and hold harmless Service Provider from any demands, claims, damages, liabilities, expenses or harms,
                                including attorney’s fees, arising in connection with errors or acts of omissions on declarations to JCA. Moreover,
                                I will indemnify, and hold harmless Service Provider for any errors made or acts of omissions made by JCA in respect to valuation of shipments.
                                Service Provider will have no responsibility or liability in cases where I am found in breach of applicable import laws, quotas, restrictions,
                                and permit/licensing requirements.
                            </p>

                        </li>
                        <li>
                            <p style={{ marginTop: 5, marginLeft: 5 }}>
                                I will defend, indemnify, and hold harmless Service Provider in respect of any penalty levied by the Jamaica Customs Agency
                                and in respect of the seizure by the Jamaica Customs Agency of any Cargo sent by or consigned to me.
                            </p>
                        </li>
                    </ol>
                </Col>

            </Row>
        )
    }
}
